import * as Ably from 'ably';
import { makeRequest } from '../util/AxiosInstance';
import Push from "ably/push";

export const createRealtimeClient = () => new Ably.Realtime({
    useTokenAuth: true,
    authUrl: `${import.meta.env.VITE_API_URL}/realtime`,
    authCallback: async (tokenParams, callback) => {
        let tokenRequest;
        try {
            let response = await makeRequest('GET', '/realtime');
            tokenRequest = response.data?.data;
        } catch (err) {
            callback(err, null);
            return;
        }
        callback(null, tokenRequest);
    },
    pushServiceWorkerUrl: '/service-worker.js',
    plugins: { Push }
});